export default class Price {

    static bless( data: any ) {
        return ( data && new Price(data.nightly, data.weekly) );
    }

    constructor( public nightly: number,
                 public weekly?: number ) {
    }

}



/** WEBPACK FOOTER **
 ** ./src/models/Price.ts
 **/